module.exports = __webpack_public_path__ + "media/conversa/logo_Conversa_Color_Part-ec9973f4.png";